import React from "react";
import { connect } from "react-redux";
import ResetForm from "../forms/ResetForm";
import { login, isTokenValid } from "../../actions/auth";
import ForgotPasswordSteps from "./ForgotPasswordSteps";
import SideInfoPane from "../navigation/SideInfoPane";
import ChangePasswordForm from "../forms/ChangePasswordForm";
import api from "../../api";
import settings from "../../settings";
import "../../App.css";
import TopNavigation from "../navigation/TopNavigation";

class ForgotPasswordPage extends React.Component {
  constructor(props) {
    super(props);
    const steps = [];
    let resetkey = "";
    if (props.location.search && props.location.search !== "") {
      const params = new URLSearchParams(props.location.search);
      resetkey = params.get("resetkey");
    }
    if (resetkey && resetkey !== "") {
      steps[0] = 2;
      steps[1] = 2;
      steps[2] = 1;
    } else {
      steps[0] = 1;
      steps[1] = 0;
      steps[2] = 0;
    }
    let resetError = "";
    if (localStorage.loginFailed) {
      resetError = localStorage.loginFailed;
    }
    this.state = {
      resetError,
      changePasswordError: "",
      confirmationMessage: "",
      steps,
      resetkey,
    };
  }

  submit = (data) =>
    api.user
      .resetPasswordToTemp({
        userCode: data.username,
        appname: settings.appName,
        emailType: "PasswordResetEmail",
        linkAction: "changepassword",
        responseEmailType: "ConfirmEmail",
      })
      .then((res) => {
        if (res.data.Error) {
          this.setState({ resetError: res.data.Error.Message });
        } else {
          const steps = [];
          steps[0] = 2;
          steps[1] = 1;
          steps[2] = 0;
          this.setState({ steps, confirmationMessage: res.data.Message });
        }
      })
      .catch((err) => console.log("response err - ", err.response));

  submitChangePassword = (data) =>
    api.user
      .changePassword({
        userCode: data.username,
        resetkey: this.state.resetkey,
        appname: settings.appName,
        password: data.password,
      })
      .then((res) => {
        if (res.data.Error) {
          this.setState({ changePasswordError: res.data.Error.Message });
        } else {
          this.props
            .login({
              username: data.username,
              password: data.password,
              appname: settings.appName,
            })
            .then(() => {
              if (!localStorage.appToken) {
                this.setState({ loginError: "Invalid username or password" });
              } else {
                window.location.href = `./securitytoken`;
                this.setState({ loginError: "" });
              }
            })
            .catch((err) => console.log("response err - ", err.response));
        }
      })
      .catch((err) => console.log("response err - ", err));

  render() {
    return (
      <div>
        <TopNavigation />
        <div className="col-lg-12 col-md-12 col-sm-12">
          <div className="container-fluid padding-top-20">
            {this.state.steps[0] === 1 && (
              <div className="row login-box">
                <div className="row" colSpan={3}>
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-11 col-md-11 col-sm-11">
                    <div className="padding-top-10" />
                    <ForgotPasswordSteps steps={this.state.steps} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-5 col-md-5 col-sm-5 login-box-left">
                    <div className="padding-top-10" />

                    <h2 className="font-family">Password Reset</h2>

                    <ResetForm
                      submit={this.submit}
                      resetError={this.state.resetError}
                    />
                    <div className="padding-top-10" />

                    <div className="padding-top-20 hide-on-smallscreen padding-top-3" />
                  </div>

                  <div className="col-lg-2 col-md-2 col-sm-2" />

                  <div className="col-lg-4 col-md-4 col-sm-4 login-box-right padding-top-25">
                    <SideInfoPane />
                  </div>
                </div>
              </div>
            )}
            {this.state.steps[1] === 1 && (
              <div className="row login-box">
                <div className="row" colSpan={3}>
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-11 col-md-11 col-sm-11">
                    <div className="padding-top-10" />
                    <ForgotPasswordSteps steps={this.state.steps} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-5 col-md-5 col-sm-5 login-box-left">
                    <div className="padding-top-10" />

                    <h2 className="font-family">Password Reset Confirmation</h2>
                    <div
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: this.state.confirmationMessage,
                      }}
                    />
                    <div className="padding-top-10" />

                    <div className="padding-top-20 hide-on-smallscreen padding-top-3" />
                  </div>

                  <div className="col-lg-2 col-md-2 col-sm-2" />

                  <div className="col-lg-4 col-md-4 col-sm-4 login-box-right padding-top-25">
                    <SideInfoPane />
                  </div>
                </div>
              </div>
            )}
            {this.state.steps[2] === 1 && (
              <div className="row login-box">
                <div className="row" colSpan={3}>
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-11 col-md-11 col-sm-11">
                    <div className="padding-top-10" />
                    <ForgotPasswordSteps steps={this.state.steps} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-5 col-md-5 col-sm-5 login-box-left">
                    <div className="padding-top-10" />

                    <h2 className="font-family">New Password Activation</h2>
                    <ChangePasswordForm
                      submit={this.submitChangePassword}
                      changePasswordError={this.state.changePasswordError}
                    />
                    <div className="padding-top-10" />

                    <div className="padding-top-20 hide-on-smallscreen padding-top-3" />
                  </div>

                  <div className="col-lg-2 col-md-2 col-sm-2" />

                  <div className="col-lg-4 col-md-4 col-sm-4 login-box-right padding-top-25">
                    <SideInfoPane />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isAuthenticated: !!state.user.token,
  };
}

export default connect(mapStateToProps, { login, isTokenValid })(
  ForgotPasswordPage
);



// WEBPACK FOOTER //
// ./src/components/pages/ForgotPasswordPage.js